export default __webpack_public_path__ + "locales/hy-AM/Ldap.json?hash=83b0b6a6d52f818f822fcf6bab985d87";